export interface Booking {
    id: string
    hash: string
}

export interface BookingResult {
    bookings: Booking[]
}

export const BookingStatusMap = {
    NOT_PAID: "not_paid",
    PAY_STARTED: "pay_started",
    PAY_ERROR: "pay_error",
    PAID: "paid",
    CANCELLED: "cancelled_without_payment",
    CANCELLED_AFTER_PAYMENT: "cancelled_with_refund",
    CANCELLED_WITHOUT_REFUND: "cancelled_without_refund",
    PAID_AFTER_CANCELLATION: "paid_after_cancellation",
} as const

export const BookingStatusNameMap = {
    [BookingStatusMap.NOT_PAID]: "Не оплачено",
    [BookingStatusMap.PAY_STARTED]: "Оплата начата",
    [BookingStatusMap.PAY_ERROR]: "Ошибка оплаты",
    [BookingStatusMap.PAID]: "Оплачено",
    [BookingStatusMap.CANCELLED]: "Отменено до оплаты (сессия не была подтверждена)",
    [BookingStatusMap.CANCELLED_AFTER_PAYMENT]: "Отменено с возвратом денег",
    [BookingStatusMap.CANCELLED_WITHOUT_REFUND]: "Отменено без возврата денег",
    [BookingStatusMap.PAID_AFTER_CANCELLATION]: "Оплачено после отмены",
} as Record<BookingStatus, string>

export type BookingStatus = (typeof BookingStatusMap)[keyof typeof BookingStatusMap]
